<template>
  <AtomLink
    v-if="url"
    :url="url"
    class="group relative inline-flex items-stretch border-2 border-solid border-app-green border-app-green-100 rounded-lg overflow-hidden md:rounded-xl"
    :style="`border-color: ${iconHex || undefined}`"
  >
    <figure class="flex shrink-0 items-center justify-center w-16 h-16 bg-app-green" :style="`background-color: ${iconHex || undefined}`">
      <AtomIcon v-if="iconSlug" :icon="iconSlug" class="v-hover-zoom-image w-12 h-12 text-white transform transition duration-200" />
    </figure>
    <div class="flex flex-auto items-center justify-between px-4 text-black bg-white md:px-8">
      <span v-if="title" class="mr-20 leading-tight">
        {{ t_('i-am-a') }}
        <strong class="font-bold">{{ title }}</strong>
      </span>
      <AtomIconArrowRight
        class="c-icon-read-more absolute right-0 top-0 shrink-0 mr-6 w-5 h-5 text-app-green transform group-hover:translate-x-1 transition duration-200"
        :style="`color: ${iconHex || undefined}`"
      />
    </div>
  </AtomLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { setupTranslationPrefixer } from '~/composables/util'

interface Props {
  icon?: { slug?: string }
  iconColor?: { hex?: string }
  reference?: { url?: string }
  title?: string
}

const props = defineProps<Props>()

const { t_ } = setupTranslationPrefixer('AnimalMeetYourMatch')

const iconHex = computed(() => props.iconColor?.hex)
const iconSlug = computed(() => props.icon?.slug)
const url = computed(() => props.reference?.url)
</script>

<style lang="css" scoped>
.c-icon-read-more {
  top: 50%;
  margin-top: -10px;
}
</style>
